import { createReducer, createSelector } from 'redux-starter-kit';
import {putBucketBalances} from "./creditBalanceActions";


/**
 * A selector map for the bucket balances loaded in the domain state.
 */
export const selectBucketBalancesMap = state => state.via.domain.bucketBalances;


/**
 * A selector for the bucket balances loaded in the domain state.
 */
export const selectBucketBalances = createSelector(['via.domain.bucketBalances'], map => (map ? Object.values(map) : null));


/**
 * A selector for a bucket balance that is loaded in the domain state.
 */
export const selectBucketBalance = (state, id) => {
  const balancesMap = selectBucketBalancesMap(state);
  if (!balancesMap) return null;

  return balancesMap[id];
};

export default createReducer({}, {
  // Replaces all the bucket balances in the state.
  [putBucketBalances]: (state, action) => {
    const balances = action.payload;

    return balances.reduce((newState, balance) => {
      newState[balance.id] = balance; // eslint-disable-line no-param-reassign
      return newState;
    }, { });
  },

});
